import { defineComponent as _defineComponent } from 'vue'
import { ref } from "vue"
import AppDetailPage from "@/components/layout/AppDetailPage.vue"
import { useQuery } from "@vue/apollo-composable"
import { ApplicantDetailQuery, ApplicantDetailQueryQuery, Applicant } from "@/gql"
import useRouter from "@/router/useRouter"

import ApplicationDetail from "./ApplicationDetail.vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'ApplicationDetailPage',
  setup(__props) {

const { router } = useRouter()

const { loading, onResult } = useQuery<ApplicantDetailQueryQuery>(ApplicantDetailQuery, {
  filter: {
    idIn: [router.currentRoute.params.id],
  },
  per: 1,
})

const applicant = ref<Applicant | undefined>(undefined)

onResult((result) => {
  if (result.data) {
    applicant.value = result.data.applicants.data[0] as Applicant
  }
})

return { __sfc: true,router, loading, onResult, applicant, AppDetailPage, ApplicationDetail }
}

})